"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabeledValue = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const Value = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ bold: true, as: 'dd' })).withConfig({ displayName: "reports-Value", componentId: "reports-300h2t" }) `
  font-size: 20px; /* seems like we may have a use case for > md Copy sizes */
  line-height: 1;
`;
const Label = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ as: 'dt' })).withConfig({ displayName: "reports-Label", componentId: "reports-19bxqgs" }) ``;
const Dl = styled_components_1.default.dl.withConfig({ displayName: "reports-Dl", componentId: "reports-e772ds" }) `
  height: 100%;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  gap: 8px;
  margin: 0;
  padding: ${({ status }) => (status ? '8px' : '8px 0')};
  text-align: ${({ labelAlign }) => labelAlign !== null && labelAlign !== void 0 ? labelAlign : 'left'};

  background-color: ${({ status }) => (status ? base_react_components_1.theme.statusColors[status].backgroundColor : 'transparent')};
  border-bottom-color: ${({ underbar }) => (underbar === 'below' ? base_react_components_1.theme.neutral200 : 'transparent')};
  border-radius: 12px;

  & > ${Label} {
    align-self: end;
  }
  & > ${Value} {
    text-align: ${({ valueAlign }) => valueAlign !== null && valueAlign !== void 0 ? valueAlign : 'left'};
    align-items: center;
    &::before {
      ${({ underbar }) => (underbar === 'between' ? `content: ''` : '')};
      margin-bottom: 8px;
      border-top: 2px solid ${base_react_components_1.theme.neutral200};
      display: block;
    }
  }
`;
/**
 * The LabeledValue displays a value and an associated label that describes what the value represents.
 */
const LabeledValue = (_a) => {
    var { label = '', status, underbar = 'between', children, 'data-testid': testId = '' } = _a, props = __rest(_a, ["label", "status", "underbar", "children", 'data-testid']);
    return (react_1.default.createElement(Dl, Object.assign({ underbar: underbar, status: status, "data-testid": `labeled-value ${testId}` }, props),
        react_1.default.createElement(Label, { "data-testid": "labeled-value:label" }, label),
        react_1.default.createElement(Value, { "data-testid": "labeled-value:value" }, children)));
};
exports.LabeledValue = LabeledValue;
exports.default = exports.LabeledValue;
//# sourceMappingURL=index.js.map